import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const StatCounter = ({ value, suffix = "", label, "data-testid": testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const duration = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <div ref={ref} className="text-center md:text-left" data-testid={testId}>
      <div className="gold-numeral stat-num" style={{ fontSize: "48px", lineHeight: 1 }}>
        {display}
        {suffix}
      </div>
      <div
        className="mt-3 uppercase"
        style={{
          color: "var(--text-light)",
          fontWeight: 500,
          fontSize: "13px",
          letterSpacing: "0.16em",
          opacity: 0.7,
        }}
      >
        {label}
      </div>
    </div>
  );
};
